import getMediaUrl from "../../../utils/mediaUrl"

export const createTheme = (gameData, strapiUrl) => {
  const theme = {
    colors: {
      primary: gameData?.game_colors?.host_text_primary || "#1A1A3A",
      secondary: "#fff",

      host_background: gameData?.game_colors?.host_background || "#fff",

      host_centerpiece_background:
        gameData?.game_colors?.host_centerpiece_background ||
        "rgba(255,255,255,0.8)",
      host_centerpiece_border:
        gameData?.game_colors?.host_centerpiece_border ||
        "rgba(255,255,255,0.8)",

      host_text_primary: gameData?.game_colors?.host_text_primary || "#1A1A3A",
      host_text_accent: gameData?.game_colors?.host_text_accent || "#F49102",

      host_button_background:
        gameData?.game_colors?.host_button_background || "#F49102",
      host_button_text: gameData?.game_colors?.host_button_text || "#fff",
      host_button_border:
        gameData?.game_colors?.host_button_background || "transparent",

      host_players_background:
        gameData?.game_colors?.host_players_background ||
        "rgba(255, 255, 255, 0.5)",
      host_players_border:
        gameData?.game_colors?.host_players_border || "white",
      host_player_background:
        gameData?.game_colors?.host_player_background || "white",
      host_player_border: gameData?.game_colors?.host_player_border || "white",

      guest_background: gameData?.game_colors?.guest_background || "#fff",
      guest_text_primary:
        gameData?.game_colors?.guest_text_primary || "#1A1A3A",
      guest_text_accent: gameData?.game_colors?.guest_text_accent || "#F49102",
    },
    images: {
      host_default_background_image:
        getMediaUrl(
          strapiUrl,
          gameData?.game_defaults?.host_default_background_image?.url
        ) || "",
      guest_default_question_image:
        getMediaUrl(
          strapiUrl,
          gameData?.game_defaults?.guest_default_question_image?.url
        ) || "",
    },
  }
  return theme
}
